'use client';

import type { ComponentProps } from 'react';
import logPrintMapButtonClicked from '@alltrails/amplitude/events/logPrintMapButtonClicked';
import Link from '@alltrails/denali/components/Link';

const PrintMapsFooterLink = ({ children, ...linkProps }: ComponentProps<typeof Link>) => (
  <Link {...linkProps} onClick={() => logPrintMapButtonClicked({ map_location: 'explore' })}>
    {children}
  </Link>
);

export default PrintMapsFooterLink;
